// This app's own preferences — the kit's persistent store, one key each, read
// wherever they matter and set from the app's pane in Preferences (App.jsx).
import { createPersistentStore } from '@ofself/shell';

// The mark's voice: each string the pointer brushes sounds a struck-bar tone.
// Off unless chosen — a page that makes sound on hover must be asked for.
export const markSoundStore = createPersistentStore('ig-mark-sound', false);
